const STORAGE_MIGRATION_ERROR = (key: string): string =>
  `Failed to retrieve or parse data for ${key} from storage.`;

export { STORAGE_MIGRATION_ERROR };
